export const HOME_HERO_VARIANTS = [
  "strategija",
  "nuovargis",
  "rezultatai",
] as const;

export type HomeHeroVariant = (typeof HOME_HERO_VARIANTS)[number];

export const isValidHomeHeroVariant = (
  value: string | null | undefined,
): value is HomeHeroVariant =>
  HOME_HERO_VARIANTS.includes(value as HomeHeroVariant);

export const HOME_HERO_KLAVIYO_CONFIG: Record<
  HomeHeroVariant,
  {
    formId: string;
    metricType: string;
    emailList: string;
  }
> = {
  strategija: {
    formId: "SA5r95",
    metricType: "strategija",
    emailList: "nuovargis- verslininkas",
  },
  nuovargis: {
    formId: "ThkMnH",
    metricType: "nuovargis",
    emailList: "nuovargis - šeimos sveikatos architektė",
  },
  rezultatai: {
    formId: "Vu6sym",
    metricType: "rezultatai",
    emailList: "nuovargis - biohackeris",
  },
};
